import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewportService } from 'src/app/services/viewport.service';
import {UserModel} from '../../../models/User';
import {Router} from '@angular/router';

@Component({
  selector: 'perks-warning-modal',
  templateUrl: './perks-warning-modal.component.html',
  styleUrl: './perks-warning-modal.component.css'
})
export class PerksWarningModalComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Output() onClose = new EventEmitter<void>();
  @Input() user: UserModel;

  constructor(
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      public viewport: ViewportService,
      private router: Router
  ) {}

  ngOnInit() {
      this.user = this.config.data.user
  }
  ngOnDestroy(): void {}

    goToUpgrade() {
        this.router.navigate([this.user.upgradeLink], {
            queryParams: {
                upgrade_source: 'dashboard_perks',
                upgrade_campaign: '1_14_day_trial',
                upgrade_cohort: '2026'
            }
        });
        this.close();
    }
  hide() {
      this.onClose.emit();
  }

  close() {
      this.ref.close();
  }
}
